/** True for local development (Vite dev server or localhost). Kept in its own module so jest, which cannot parse import.meta, can mock it. */
export function isDevelopment(): boolean {
  return import.meta.env.DEV || window.location.hostname === 'localhost';
}
